module.exports = __webpack_public_path__ + "static/img/smart_guard.21677805.png";